import React from 'react';

const PostInstallSuccess = ({ onClose }) => {
  return (
    <div className="fixed inset-0 z-[9999] bg-gradient-to-br from-emerald-500 via-teal-500 to-cyan-500 flex items-center justify-center p-6">
      <div className="max-w-md w-full text-center text-white">
        {/* Success Animation */}
        <div className="mb-8 animate-bounce">
          <div className="inline-flex items-center justify-center w-32 h-32 bg-white/20 backdrop-blur-sm rounded-full mb-4">
            <span className="text-7xl">✅</span>
          </div>
        </div>

        {/* Title */}
        <h1 className="text-4xl font-bold mb-4 animate-fade-in">
          Successfully Installed!
        </h1>

        {/* Subtitle */}
        <p className="text-xl mb-8 text-emerald-50">
          Happy Paws is now on your home screen
        </p>

        {/* Visual Guide - Simulated Phone Home Screen */}
        <div className="bg-white/10 backdrop-blur-md rounded-3xl p-6 mb-8 border-2 border-white/30">
          <p className="text-emerald-50 text-sm mb-4 font-semibold">
            📱 Look for the Happy Paws icon:
          </p>
          
          {/* Simulated Home Screen Grid */}
          <div className="grid grid-cols-4 gap-4 mb-4">
            {/* Dummy app icons */}
            <div className="flex flex-col items-center opacity-40">
              <div className="w-14 h-14 bg-blue-400 rounded-2xl mb-1"></div>
              <span className="text-[10px] text-white/70">App</span>
            </div>
            <div className="flex flex-col items-center opacity-40">
              <div className="w-14 h-14 bg-purple-400 rounded-2xl mb-1"></div>
              <span className="text-[10px] text-white/70">App</span>
            </div>
            
            {/* Happy Paws Icon - Highlighted */}
            <div className="flex flex-col items-center relative animate-pulse">
              <div className="absolute -inset-2 bg-yellow-400 rounded-full opacity-50 animate-ping"></div>
              <div className="w-14 h-14 bg-white rounded-2xl mb-1 flex items-center justify-center relative z-10 shadow-2xl">
                <svg width="40" height="40" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="28" cy="28" r="24" fill="white" stroke="#10B981" strokeWidth="3"/>
                  <text x="28" y="36" fontSize="28" textAnchor="middle" dominantBaseline="middle">🐾</text>
                </svg>
              </div>
              <span className="text-[10px] font-bold text-white relative z-10">Happy Paws</span>
              <div className="absolute -bottom-3 text-3xl animate-bounce">👆</div>
            </div>
            
            <div className="flex flex-col items-center opacity-40">
              <div className="w-14 h-14 bg-red-400 rounded-2xl mb-1"></div>
              <span className="text-[10px] text-white/70">App</span>
            </div>
          </div>

          <div className="bg-emerald-600 rounded-xl p-4 mt-4">
            <p className="text-white text-sm font-semibold mb-2">
              📱 What to Do Next:
            </p>
            <ol className="text-left text-sm text-emerald-50 space-y-2">
              <li>1️⃣ Close this tab</li>
              <li>2️⃣ Wait <strong>up to 30 seconds</strong> for icon to appear</li>
              <li>3️⃣ Tap the 🐾 Happy Paws icon</li>
              <li>4️⃣ Start exploring! <strong>(Works immediately)</strong></li>
            </ol>
          </div>
          
          {/* Reassurance - No Settings Needed */}
          <div className="bg-emerald-700 rounded-xl p-4 mt-3 border-2 border-emerald-400">
            <p className="text-white text-sm font-bold mb-1">
              ✅ No Extra Steps Required
            </p>
            <p className="text-emerald-50 text-xs">
              You do NOT need to go to Settings. Just wait for the icon, then tap it!
            </p>
          </div>
        </div>

        {/* Action Button */}
        <button
          onClick={() => {
            // Try to close the tab
            window.close();
            // If that doesn't work, user will manually close
            onClose();
          }}
          className="bg-white text-emerald-600 font-bold py-4 px-8 rounded-full text-lg shadow-2xl hover:shadow-white/50 transition-all duration-300 transform hover:scale-105 mb-4"
        >
          I Found It! ✨
        </button>

        {/* Small print */}
        <p className="text-sm text-emerald-100 opacity-75 mb-2">
          Tap the button above or close this tab manually
        </p>
        
        {/* Pro tip - Compact */}
        <div className="bg-white/10 backdrop-blur-sm rounded-lg p-3 mt-4">
          <p className="text-xs text-emerald-50">
            💡 <strong>Can't find it?</strong> Swipe between home screens - the icon may appear on a different page.
          </p>
        </div>
      </div>

      {/* Animations */}
      <style>{`
        @keyframes fade-in {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        .animate-fade-in {
          animation: fade-in 0.6s ease-out;
        }
      `}</style>
    </div>
  );
};

export default PostInstallSuccess;
